// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Button, Card, Row, Col, Space, Typography, Table, Select, message, Modal
// } from 'antd';
// import { useLocation, useNavigate } from 'react-router-dom';
// import moment from 'moment';
// import { CheckCircleOutlined, QrcodeOutlined } from '@ant-design/icons';
// import Webcam from 'react-webcam';
// import { BrowserMultiFormatReader } from '@zxing/browser';
// import { DecodeHintType, BarcodeFormat } from '@zxing/library';
// import beepSound from '../../../assets/dashboard/scan-beep.mp3';
// import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// const { Title, Text } = Typography;

// const BarcodeReviewPage = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const userData = JSON.parse(localStorage.getItem('userData'));
//   const [selectedLine, setSelectedLine] = useState('');
//   const [date, setDate] = useState(moment().startOf('day'));
//   const [itemNo, setItemNo] = useState('');
//   const [lineItems, setLineItems] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [userName, setUserName] = useState(userData?.data?.full_name || 'Unknown User');
//   const [scanningRow, setScanningRow] = useState(null);

//   const webcamRef = useRef(null);
//   const codeReaderRef = useRef(null);
//   const beepSoundRef = useRef(new Audio(beepSound));

//   useEffect(() => {
//     if (userData?.data?.su_id) {
//       fetchLinesAndItems(userData.data.su_id);
//     }
//     if (state?.line_no) {
//       setSelectedLine(state.line_no);
//     } else if (state?.barcode) {
//       setItemNo(state.barcode);
//     }
//   }, [state, userData?.data?.su_id]);

//   useEffect(() => {
//     if (selectedLine && date) {
//       fetchEolReviewData();
//     }
//   }, [selectedLine, date]);

//   const fetchLinesAndItems = async (su_id) => {
//     setLoading(true);
//     try {
//       const res = await DispatchCheckerService.get_userline_and_items(su_id);
//       if (res.status && Array.isArray(res.line_data)) {
//         setLineItems(res.line_data);
//         if (!selectedLine && res.line_data.length > 0) {
//           setSelectedLine(res.line_data[0].line_no);
//           setItemNo(res.line_data[0].items[0]?.item_no || '');
//         }
//       } else {
//         message.error(res.message || 'No lines or items available');
//       }
//     } catch (e) {
//       console.error('Error fetching lines and items:', e);
//       message.error('Failed to fetch lines and items');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchEolReviewData = async () => {
//     if (!selectedLine || !date) return;
//     setLoading(true);
//     try {
//       const res = await DispatchCheckerService.get_eol_review_data(selectedLine, date.format('YYYY-MM-DD'));
//       if (res.status && Array.isArray(res.data.hourly_data)) {
//         const dataWithReview = res.data.hourly_data.map(item => ({
//           ...item,
//           key: item.time_id,
//           eol_reviews: item.eol_reviews || [],
//         }));
//         setTableData(dataWithReview);
//       } else {
//         setTableData([]);
//         message.error(res.message || 'No data available for the selected line and date');
//       }
//     } catch (e) {
//       console.error('Error fetching EOL review data:', e);
//       message.error('Failed to fetch EOL review data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLineChange = value => {
//     setSelectedLine(value);
//     const selectedLineData = lineItems.find(line => line.line_no === value);
//     setItemNo(selectedLineData?.items[0]?.item_no || '');
//   };

//   const handleDateChange = date => setDate(date ? moment(date) : null);

//   const disabledDate = current => {
//     const today = moment().startOf('day');
//     const max = moment().add(10, 'years').startOf('day');
//     return current < today.clone().subtract(10, 'years') || current > max;
//   };

//   const startBarcodeScan = (record) => {
//     setScanningRow(record);
//     setTimeout(() => scanBarcode(record), 300);
//   };

//   const scanBarcode = async (record) => {
//     const hints = new Map();
//     hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.CODE_128]);
//     const codeReader = new BrowserMultiFormatReader(hints);
//     codeReaderRef.current = codeReader;

//     try {
//       const result = await codeReader.decodeOnceFromVideoElement(webcamRef.current.video);
//       const scannedText = result.getText();
//       beepSoundRef.current?.play();
//       await submitReview(record, scannedText);
//     } catch (error) {
//       message.error('Barcode scan failed');
//       console.error('Barcode scan error:', error);
//     } finally {
//       setScanningRow(null);
//       codeReader.reset?.();
//     }
//   };

//   const submitReview = async (record, barcode) => {
//     const currentHour = moment().format('HH:mm:ss');
//     const currentDate = moment().format('YYYY-MM-DD');
//     try {
//       const res = await DispatchCheckerService.store_eol_review(
//         selectedLine,
//         record.time_id,
//         currentDate,
//         barcode,
//         currentHour,
//         userData?.data?.su_id || 'unknown'
//       );
//       if (res.status) {
//         message.success('Review recorded successfully');
//         await fetchEolReviewData();
//       } else {
//         message.error(res.message || 'Review submission failed');
//       }
//     } catch (e) {
//       console.error('Error submitting review:', e);
//       message.error('Failed to submit review');
//     }
//   };

//   const columns = [
//     { title: '#', dataIndex: 'time_id', key: 'time_id', width: 50 },
//     { title: 'Time Slot', dataIndex: 'time_slot', width: 100 },
//     { title: 'Inspected', dataIndex: 'total_inspected', width: 100 },
//     { title: 'Passed', dataIndex: 'total_passed', width: 100 },
//     { title: 'Rejected', dataIndex: 'total_rejects', width: 100 },
//     { title: 'Defectives', dataIndex: 'total_defectives', width: 100 },
//     { title: 'Defects', dataIndex: 'total_defects', width: 100 },
//     {
//       title: 'Action',
//       key: 'action',
//       width: 150,
//       render: (_, record) => {
//         const hasReview = record.eol_reviews && Array.isArray(record.eol_reviews) && record.eol_reviews.length > 0;
//         if (hasReview) {
//           const latestReview = record.eol_reviews.reduce((latest, current) =>
//             moment(latest.added_on).isAfter(moment(current.added_on)) ? latest : current
//           );
//           return (
//             <Space direction="vertical" size={4}>
//               <Space>
//                 <CheckCircleOutlined style={{ color: 'green' }} />
//                 <Text type="success">Reviewed</Text>
//               </Space>
//               <Text type="secondary" style={{ fontSize: '12px' }}>
//                 By {latestReview.full_name} on {latestReview.review_date} at {latestReview.hour}
//               </Text>
//             </Space>
//           );
//         }
//         return (
//           <Button
//             type="primary"
//             icon={<QrcodeOutlined />}
//             onClick={() => startBarcodeScan(record)}
//             size="small"
//           >
//             Review
//           </Button>
//         );
//       },
//     },
//   ];

//   return (
//     <div style={{ padding: '16px' }}>
//       <Card title={`End of Line Review - ${userName}`}>
//         <audio ref={beepSoundRef} src={beepSound} preload="auto" />
//         <Row gutter={[16, 16]}>
//           <Col xs={24} sm={12} md={8}>
//             <Text strong>Line:</Text>
//             <Select
//               style={{ width: '100%' }}
//               value={selectedLine}
//               onChange={handleLineChange}
//               size="large"
//             >
//               {lineItems.map(line => (
//                 <Select.Option key={line.line_no} value={line.line_no}>
//                   {line.line_no}
//                 </Select.Option>
//               ))}
//             </Select>
//           </Col>
//           <Col xs={24} sm={12} md={8}>
//             <Text strong>Item:</Text>
//             <Select
//               style={{ width: '100%' }}
//               value={itemNo}
//               onChange={setItemNo}
//               size="large"
//             >
//               {lineItems
//                 .find(line => line.line_no === selectedLine)
//                 ?.items.map(item => (
//                   <Select.Option key={item.item_no} value={item.item_no}>
//                     {item.item_no}
//                   </Select.Option>
//                 ))}
//             </Select>
//           </Col>
//           <Col xs={24} sm={12} md={8}>
//             <Text strong>Date:</Text>
//             <div style={{ width: '100%' }}>
//               <DatePicker
//                 selected={date?.toDate()}
//                 onChange={handleDateChange}
//                 maxDate={new Date()}
//                 minDate={moment().subtract(10, 'years').toDate()}
//                 dateFormat="yyyy-MM-dd"
//                 todayButton="Today"
//                 placeholderText="Select date"
//                 className="custom-date-picker"
//               />
//             </div>
//           </Col>
//         </Row>

//         <Table
//           style={{ marginTop: 16 }}
//           columns={columns}
//           dataSource={tableData}
//           loading={loading}
//           pagination={false}
//           bordered
//           scroll={{ x: 800 }}
//           size="small"
//         />

//         {scanningRow && (
//           <Modal
//             open={true}
//             footer={null}
//             onCancel={() => setScanningRow(null)}
//             width={window.innerWidth < 768 ? '90%' : 520}
//           >
//             <Webcam
//               ref={webcamRef}
//               audio={false}
//               screenshotFormat="image/jpeg"
//               width="100%"
//               videoConstraints={{ facingMode: 'environment' }}
//               style={{ maxWidth: '100%', height: 'auto' }}
//             />
//             <p style={{ textAlign: 'center', marginTop: 8 }}>Scanning for barcode...</p>
//           </Modal>
//         )}
//       </Card>

//       <style>
//         {`
//           .custom-date-picker {
//             width: 100%;
//             height: 40px;
//             padding: 8px 12px;
//             border: 1px solid #d9d9d9;
//             border-radius: 6px;
//             font-size: 14px;
//             line-height: 1.5;
//             color: rgba(0, 0, 0, 0.88);
//             background-color: #fff;
//             box-shadow: none;
//             transition: all 0.3s;
//             box-sizing: border-box;
//           }
//           .custom-date-picker:focus {
//             border-color: #4096ff;
//             outline: none;
//             box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
//           }
//           .react-datepicker {
//             font-family: 'Roboto', sans-serif;
//             font-size: 14px;
//           }
//           .react-datepicker__day--selected {
//             background-color: #4096ff !important;
//             color: white;
//           }
//           .react-datepicker__day--keyboard-selected {
//             background-color: #91caff !important;
//           }
//           .ant-table {
//             font-size: 12px;
//           }
//           .ant-table-thead > tr > th {
//             white-space: nowrap;
//           }
//           .ant-table-tbody > tr > td {
//             white-space: nowrap;
//           }
//           @media (max-width: 768px) {
//             .ant-card-body {
//               padding: 16px;
//             }
//             .ant-select-selector {
//               font-size: 12px;
//               height: 36px !important;
//             }
//             .ant-btn {
//               font-size: 12px;
//               padding: 4px 8px;
//             }
//             .custom-date-picker {
//               height: 36px;
//               font-size: 12px;
//             }
//             .ant-table {
//               font-size: 10px;
//             }
//             .ant-table-thead > tr > th,
//             .ant-table-tbody > tr > td {
//               padding: 8px 4px;
//             }
//           }
//           @media (max-width: 576px) {
//             .ant-card-title {
//               font-size: 16px;
//             }
//             .ant-select-selector {
//               font-size: 10px;
//               height: 32px !important;
//             }
//             .custom-date-picker {
//               height: 32px;
//               font-size: 10px;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default BarcodeReviewPage;
import React, { useState, useEffect, useRef } from 'react';
import {
  Button, Card, Row, Col, Space, Typography, Table, Select, message, Modal
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CheckCircleOutlined, QrcodeOutlined } from '@ant-design/icons';
import Webcam from 'react-webcam';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { DecodeHintType, BarcodeFormat } from '@zxing/library';
import beepSound from '../../../assets/dashboard/scan-beep.mp3';
import DispatchCheckerService from '../../../services/Dispatch-Checker/DispatchCheckerService';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const { Title, Text } = Typography;

const BarcodeReviewPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [selectedLine, setSelectedLine] = useState('');
  const [date, setDate] = useState(moment().startOf('day'));
  const [itemNo, setItemNo] = useState('');
  const [lineItems, setLineItems] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState(userData?.data?.full_name || 'Unknown User');
  const [scanningRow, setScanningRow] = useState(null);

  const webcamRef = useRef(null);
  const codeReaderRef = useRef(null);
  const beepSoundRef = useRef(new Audio(beepSound));

  useEffect(() => {
    if (userData?.data?.su_id) {
      fetchLinesAndItems(userData.data.su_id);
    }
    if (state?.line_no) {
      setSelectedLine(state.line_no);
    } else if (state?.barcode) {
      setItemNo(state.barcode);
    }
  }, [state, userData?.data?.su_id]);

  useEffect(() => {
    if (selectedLine && date) {
      fetchEolReviewData();
    }
  }, [selectedLine, date]);

  const fetchLinesAndItems = async (su_id) => {
    setLoading(true);
    try {
      const res = await DispatchCheckerService.get_userline_and_items(su_id);
      if (res.status && Array.isArray(res.line_data)) {
        setLineItems(res.line_data);
        if (!selectedLine && res.line_data.length > 0) {
          setSelectedLine(res.line_data[0].line_no);
          setItemNo(res.line_data[0].items[0]?.item_no || '');
        }
      } else {
        message.error(res.message || 'No lines or items available');
      }
    } catch (e) {
      console.error('Error fetching lines and items:', e);
      message.error('Failed to fetch lines and items');
    } finally {
      setLoading(false);
    }
  };

  const fetchEolReviewData = async () => {
    if (!selectedLine || !date) return;
    setLoading(true);
    try {
      const res = await DispatchCheckerService.get_eol_review_data(selectedLine, date.format('YYYY-MM-DD'));
      if (res.status && Array.isArray(res.data.hourly_data)) {
        const dataWithReview = res.data.hourly_data.map(item => ({
          ...item,
          key: item.time_id,
          eol_reviews: item.eol_reviews || [],
        }));
        setTableData(dataWithReview);
      } else {
        setTableData([]);
        message.error(res.message || 'No data available for the selected line and date');
      }
    } catch (e) {
      console.error('Error fetching EOL review data:', e);
      message.error('Failed to fetch EOL review data');
    } finally {
      setLoading(false);
    }
  };

  const handleLineChange = value => {
    setSelectedLine(value);
    const selectedLineData = lineItems.find(line => line.line_no === value);
    setItemNo(selectedLineData?.items[0]?.item_no || '');
  };

  const handleDateChange = date => setDate(date ? moment(date) : null);

  const disabledDate = current => {
    const today = moment().startOf('day');
    const max = moment().add(10, 'years').startOf('day');
    return current < today.clone().subtract(10, 'years') || current > max;
  };

  const startBarcodeScan = (record) => {
    setScanningRow(record);
    setTimeout(() => scanBarcode(record), 300);
  };

  const scanBarcode = async (record) => {
    const hints = new Map();
    hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.CODE_128]);
    const codeReader = new BrowserMultiFormatReader(hints);
    codeReaderRef.current = codeReader;

    try {
      const result = await codeReader.decodeOnceFromVideoElement(webcamRef.current.video);
      const scannedText = result.getText();
      beepSoundRef.current?.play();
      await submitReview(record, scannedText);
    } catch (error) {
      message.error('Barcode scan failed');
      console.error('Barcode scan error:', error);
    } finally {
      setScanningRow(null);
      codeReader.reset?.();
    }
  };

  const submitReview = async (record, barcode) => {
    const currentHour = moment().format('HH:mm:ss');
    const currentDate = moment().format('YYYY-MM-DD');
    try {
      const res = await DispatchCheckerService.store_eol_review(
        selectedLine,
        record.time_id,
        currentDate,
        barcode,
        currentHour,
        userData?.data?.username || 'unknown'
      );
      if (res.status) {
        message.success('Review recorded successfully');
        await fetchEolReviewData();
      } else {
        message.error(res.message || 'Review submission failed');
      }
    } catch (e) {
      console.error('Error submitting review:', e);
      message.error('Failed to submit review');
    }
  };

  const columns = [
    { title: '#', dataIndex: 'time_id', key: 'time_id', width: 50 },
    { title: 'Time Slot', dataIndex: 'time_slot', width: 100 },
    { title: 'Inspected', dataIndex: 'total_inspected', width: 100 },
    { title: 'Passed', dataIndex: 'total_passed', width: 120,render: (text, record) => {
    const percentage = record.passed_percentage;
    return percentage ? `${text} (${percentage}%)` : text;
  }, },
    { title: 'Rejected', dataIndex: 'total_rejects', width: 100 },
    { title: 'Defectives', dataIndex: 'total_defectives', width: 120,
  render: (text, record) => {
    const percentage = record.defective_percentage;
    return percentage ? `${text} (${percentage}%)` : text;
  }, },
    { title: 'Defects', dataIndex: 'total_defects', width: 120,render: (text, record) => {
    const percentage = record.defect_percentage;
    return percentage ? `${text} (${percentage}%)` : text;
  }, },
    {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (_, record) => {
        const hasReview = record.eol_reviews && Array.isArray(record.eol_reviews) && record.eol_reviews.length > 0;
        if (hasReview) {
          const latestReview = record.eol_reviews.reduce((latest, current) =>
            moment(latest.added_on).isAfter(moment(current.added_on)) ? latest : current
          );
          return (
            <Space direction="vertical" size={4}>
              <Space>
                <CheckCircleOutlined style={{ color: 'green' }} />
                <Text type="success">Reviewed</Text>
              </Space>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                By {latestReview.full_name} on {latestReview.review_date} at {latestReview.hour}
              </Text>
            </Space>
          );
        }
        return (
          <Button
            type="primary"
            icon={<QrcodeOutlined />}
            onClick={() => startBarcodeScan(record)}
            size="small"
          >
            Review
          </Button>
        );
      },
    },
  ];

  return (
    <div style={{ padding: '16px' }}>
      <Card>
        <audio ref={beepSoundRef} src={beepSound} preload="auto" />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Text strong>Line:</Text>
            <Select
              style={{ width: '100%' }}
              value={selectedLine}
              onChange={handleLineChange}
              size="large"
            >
              {lineItems.map(line => (
                <Select.Option key={line.line_no} value={line.line_no}>
                  {line.line_no}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Text strong>Item:</Text>
            <Select
              style={{ width: '100%' }}
              value={itemNo}
              onChange={setItemNo}
              size="large"
            >
              {lineItems
                .find(line => line.line_no === selectedLine)
                ?.items.map(item => (
                  <Select.Option key={item.item_no} value={item.item_no}>
                    {item.item_no}
                  </Select.Option>
                ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Text strong>Date:</Text>
            <div style={{ width: '100%' }}>
              <DatePicker
                selected={date?.toDate()}
                onChange={handleDateChange}
                maxDate={new Date()}
                minDate={moment().subtract(10, 'years').toDate()}
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                placeholderText="Select date"
                className="custom-date-picker"
              />
            </div>
          </Col>
        </Row>

        <Table
          style={{ marginTop: 16 }}
          columns={columns}
          dataSource={tableData}
          loading={loading}
          pagination={false}
          bordered
          scroll={{ x: 800 }}
          size="small"
        />

        {scanningRow && (
          <Modal
            open={true}
            footer={null}
            onCancel={() => setScanningRow(null)}
            width={window.innerWidth < 768 ? '90%' : 520}
          >
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              width="100%"
              videoConstraints={{ facingMode: 'environment' }}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
            <p style={{ textAlign: 'center', marginTop: 8 }}>Scanning for barcode...</p>
          </Modal>
        )}
      </Card>

      <style>
        {`
          .custom-date-picker {
            width: 100%;
            height: 40px;
            padding: 8px 12px;
            border: 1px solid #d9d9d9;
            border-radius: 6px;
            font-size: 14px;
            line-height: 1.5;
            color: rgba(0, 0, 0, 0.88);
            background-color: #fff;
            box-shadow: none;
            transition: all 0.3s;
            box-sizing: border-box;
          }
          .custom-date-picker:focus {
            border-color: #4096ff;
            outline: none;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
          }
          .react-datepicker {
            font-family: 'Roboto', sans-serif;
            font-size: 14px;
          }
          .react-datepicker__day--selected {
            background-color: #4096ff !important;
            color: white;
          }
          .react-datepicker__day--keyboard-selected {
            background-color: #91caff !important;
          }
          .ant-table {
            font-size: 12px;
          }
          .ant-table-thead > tr > th {
            white-space: nowrap;
          }
          .ant-table-tbody > tr > td {
            white-space: nowrap;
          }
          @media (max-width: 768px) {
            .ant-card-body {
              padding: 16px;
            }
            .ant-select-selector {
              font-size: 12px;
              height: 36px !important;
            }
            .ant-btn {
              font-size: 12px;
              padding: 4px 8px;
            }
            .custom-date-picker {
              height: 36px;
              font-size: 12px;
            }
            .ant-table {
              font-size: 10px;
            }
            .ant-table-thead > tr > th,
            .ant-table-tbody > tr > td {
              padding: 8px 4px;
            }
          }
          @media (max-width: 576px) {
            .ant-card-title {
              font-size: 16px;
            }
            .ant-select-selector {
              font-size: 10px;
              height: 32px !important;
            }
            .custom-date-picker {
              height: 32px;
              font-size: 10px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default BarcodeReviewPage;
